
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Picnicspotnearwardha() {



  const cardData =
  {
    keyword: ' Picnic Spot Near Wardha',
    heading:  'Woodland Escape: Picnic Spot Near Wardha ',
    headingDescription: 'Woodland Escape Resort is a breathtaking destination wedding resort near Wardha, surrounded by lush greenery, serene forest trails, and beautifully landscaped lawns that create the perfect ambiance for a dream celebration. Every wedding function—from haldi and mehendi to sangeet and the grand ceremony—can be hosted amidst nature’s tranquil charm, offering couples and families an unforgettable experience. The resort features elegant open spaces, cozy cottages for stay, and customizable décor setups that blend luxury with rustic elegance. With warm hospitality, delicious catering options, and a professional team managing every detail, Woodland Escape Resort ensures a seamless and joyous wedding celebration. Whether you envision an intimate ceremony or a grand destination event, this resort near Wardha provides the ideal mix of natural beauty, comfort, and sophistication to make your special day truly magical.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Picnic Spot Near Wardha",
      "description": "Discover the best picnic spots near Wardha offering lush greenery, peaceful surroundings, and recreational activities perfect for a fun-filled day outdoors."
    },
    {
      "name": "Wardha Top Picnic Places",
      "description": "Explore the top picnic destinations in Wardha featuring scenic landscapes, well-maintained gardens, riversides, and hill views for a memorable outing."
    },
    {
      "name": "Wardha Family Picnic Spot",
      "description": "Plan a family picnic in Wardha with kid-friendly amenities, open spaces, and fun activities ensuring enjoyment for all age groups."
    },
    {
      "name": "Wardha Nature Picnic Spot",
      "description": "Reconnect with nature at Wardha’s serene picnic locations surrounded by forests, rivers, and hills, perfect for nature walks and outdoor relaxation."
    },
    {
      "name": "Affordable Picnic Spot Wardha",
      "description": "Enjoy budget-friendly picnic spots in Wardha that provide great amenities, scenic surroundings, and recreational activities without stretching your budget."
    },
    {
      "name": "Wardha Weekend Picnic",
      "description": "Spend a refreshing weekend at Wardha’s picnic spots, ideal for short trips with family or friends to unwind from city life and enjoy nature."
    },
    {
      "name": "Wardha Riverside Picnic Spot",
      "description": "Relax by the riverside at Wardha’s picnic locations, offering tranquil water views, picnic tables, and opportunities for water-based activities."
    },
    {
      "name": "Wardha Garden Picnic Spot",
      "description": "Visit beautifully maintained garden picnic spots in Wardha with flowering landscapes, seating areas, and open lawns perfect for a leisurely day out."
    },
    {
      "name": "Wardha Hill Picnic Spot",
      "description": "Enjoy panoramic hill views and cool breezes at Wardha’s hilltop picnic spots, ideal for photography, nature walks, and serene getaways."
    },
    {
      "name": "Wardha Kids Friendly Picnic Spot",
      "description": "Take your children to safe and entertaining picnic locations in Wardha with play areas, greenery, and activities designed for young ones."
    },
    {
      "name": "Wardha Scenic Picnic Spot",
      "description": "Capture stunning landscapes and enjoy breathtaking scenery at Wardha’s picnic destinations, perfect for photography and peaceful relaxation."
    },
    {
      "name": "Wardha Outdoor Picnic Spot",
      "description": "Experience open-air recreation at Wardha’s outdoor picnic spots with ample space for games, barbecues, and group activities."
    },
    {
      "name": "Wardha Picnic Spot Booking",
      "description": "Book your preferred picnic spot in Wardha in advance to ensure a hassle-free outing with guaranteed amenities and facilities."
    },
    {
      "name": "Wardha Picnic Tour Packages",
      "description": "Explore curated picnic tour packages in Wardha that include transport, meals, and guided activities for a complete day-out experience."
    },
    {
      "name": "Wardha Best Picnic Location",
      "description": "Plan your visit to the best picnic locations in Wardha combining scenic beauty, tranquility, and family-friendly activities for a memorable outing."
    }
  ],
  "tableData": [
    ["- Picnic Spot Near Wardha", "- Wardha Top Picnic Places"],
    ["- Wardha Family Picnic Spot", "- Wardha Nature Picnic Spot"],
    ["- Affordable Picnic Spot Wardha", "- Wardha Weekend Picnic"],
    ["- Wardha Riverside Picnic Spot", "- Wardha Garden Picnic Spot"],
    ["- Wardha Hill Picnic Spot", "- Wardha Kids Friendly Picnic Spot"],
    ["- Wardha Scenic Picnic Spot", "- Wardha Outdoor Picnic Spot"],
    ["- Wardha Picnic Spot Booking", "- Wardha Picnic Tour Packages"],
    ["- Wardha Best Picnic Location", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Picnic Spot Near Gondia",
    "WhyChoosedescription": "Woodland Escape Resort is an ideal picnic destination near Gondia. Surrounded by lush greenery and peaceful landscapes, it offers the perfect place to relax, unwind, and enjoy a fun day with family and friends."
  },
  {
    "WhyChooseheading": "Serene Natural Environment",
    "WhyChoosedescription": "Nestled amidst forests and open green spaces, the resort provides a calm and refreshing atmosphere. Guests can enjoy the sights and sounds of nature, away from the hustle and bustle of city life."
  },
  {
    "WhyChooseheading": "Ideal for Family and Group Outings",
    "WhyChoosedescription": "Whether you are planning a family picnic, friends’ outing, or a small group gathering, Woodland Escape Resort offers a safe and spacious environment for bonding, games, and memorable experiences."
  },
  {
    "WhyChooseheading": "Fun and Leisure Activities",
    "WhyChoosedescription": "From cycling and nature walks to light outdoor games and pond‑side relaxation, the resort offers plenty of enjoyable activities for visitors of all ages."
  },
  {
    "WhyChooseheading": "Comfortable Picnic Facilities",
    "WhyChoosedescription": "Enjoy shaded sit‑outs, clean rest zones, and well‑maintained picnic areas designed for your comfort. The resort ensures a convenient and memorable outdoor experience for everyone."
  },
  {
    "WhyChooseheading": "Delicious Food and Refreshments",
    "WhyChoosedescription": "Savor freshly prepared local dishes, snacks, and beverages during your picnic. The resort offers tasty food options to make your day even more enjoyable."
  },
  {
    "WhyChooseheading": "Easily Accessible from Gondia",
    "WhyChoosedescription": "Located just a short drive from Gondia, Woodland Escape Resort is the ideal spot for a quick and refreshing day out, letting you spend more time in nature and less time traveling."
  }
]




















  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a picnic spot near Wardha?",
    answer: "Woodland Escape Resort is one of the best picnic spots near Wardha, offering lush green surroundings, open lawns, and a peaceful environment. It’s perfect for families and friends looking to relax and enjoy a day close to nature."
  },
  {
    question: "How far is Woodland Escape Resort from Wardha city?",
    answer: "The resort is conveniently located within driving distance from Wardha, making it ideal for a day trip or weekend picnic. It’s easily accessible while providing a refreshing escape from the city."
  },
  {
    question: "What activities are available for picnic visitors at Woodland Escape Resort?",
    answer: "Guests can enjoy nature walks, outdoor games, cycling, open lawns, and dedicated kids’ play areas. The resort combines fun and relaxation for visitors of all ages."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups visiting for a picnic?",
    answer: "Absolutely! The resort is family-friendly and group-friendly, offering safe, spacious, and well-maintained areas where everyone can enjoy themselves comfortably."
  },
  {
    question: "Does Woodland Escape Resort provide food and refreshments for picnic guests?",
    answer: "Yes, the resort provides freshly prepared meals, snacks, and beverages. Picnic packages can include lunch and refreshments, ensuring a hassle-free and enjoyable experience."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Wardha?",
    answer: "You can easily book by calling or sending a WhatsApp message to our reservations team, or by visiting the official website. Advance booking is recommended, especially for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Ajay & Family, Wardha",
    text: "Our picnic at Woodland Escape Resort was amazing! The kids loved the play areas, the surroundings were beautiful, and the food was delicious. Truly the best picnic spot near Wardha!"
  },
  {
    name: "Ms. Neha & Friends, Wardha",
    text: "We had a fantastic day at Woodland Escape Resort! The greenery, open lawns, and peaceful atmosphere made it perfect for a picnic. Highly recommended for anyone near Wardha."
  }
];


























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Picnic Spot Near Wardha",
  "image": "https://woodlandescape.com/assets/images/picnic-wardha.jpg",
  "description": "Enjoy a perfect day out at the best picnic spot near Wardha. Woodlandescape Resort offers family-friendly locations, scenic gardens, riverside areas, and outdoor activities for a memorable picnic experience.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "72"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/picnic-spot-wardha"
  }
};



  return (
    <div>
<Helmet>
  <title>Picnic Spot Near Wardha | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Discover the best picnic spot near Wardha at Woodlandescape Resort. Enjoy scenic gardens, riverside views, family-friendly spaces, and outdoor activities for a fun and memorable day out." 
  />
  <meta 
    name="keywords" 
    content="Picnic Spot Near Wardha, Wardha Top Picnic Places, Wardha Family Picnic Spot, Wardha Nature Picnic Spot, Affordable Picnic Spot Wardha, Wardha Weekend Picnic, Wardha Riverside Picnic Spot, Wardha Garden Picnic Spot, Wardha Hill Picnic Spot, Wardha Kids Friendly Picnic Spot, Wardha Scenic Picnic Spot, Wardha Outdoor Picnic Spot, Wardha Picnic Spot Booking, Wardha Picnic Tour Packages, Wardha Best Picnic Location" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/36.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Picnicspotnearwardha;